<script setup lang="ts">
    import {computed} from 'vue';
    import useCpBem from '~/composables/useCpBem';
    import CpIconStandard from '~/components/cp/CpIcon/CpIconStandard/CpIconStandard.vue';
    import CpButtonIcon from '~/components/cp/CpButtonIcon/CpButtonIcon.vue';
    import CpText from '~/components/cp/CpText/CpText.vue';
    import {useCategoriesMenuStore} from '~/stores/categoriesMenuStore';
    import {useCategoriesMenu} from '~/composables/useCategoriesMenu';

    const categoriesStore = useCategoriesMenuStore();
    const {selectCategory} = useCategoriesMenu();
    const categories = computed(() => {
        return categoriesStore.parentCategories.slice(0).reverse();
    });

    const {b, e} = useCpBem('cp-nav-menu-categories-header');
</script>

<template>
    <div v-if="categories.length" :class="b" data-testid="categories-header">
        <div v-if="categories[1]" :class="e('parent')" @click="selectCategory(categories[1].id ?? '')">
            <v-img
                v-if="categories[1].image"
                :src="categories[1].image!"
                width="32"
                height="32"
                :alt="categories[1].title"
                data-testid="mini-image-categories"
            />
            <CpIconStandard icon="chevron_right" type="primary" class="mx-2" data-testid="chevron-categories" />
        </div>
        <div v-if="categories[0]" :class="e('current')" data-testid="current-category">
            <v-img
                v-if="categories[0].image"
                width="32"
                height="32"
                :src="categories[0].image!"
                :class="e('img')"
                :alt="categories[0].title"
            />
            <CpText v-if="categories[0].title" variant="body-bold" type="primary" :class="e('text')">
                {{ categories[0].title }}
            </CpText>
        </div>
        <CpButtonIcon v-if="!categories[1]"
            kind="close"
            type="primary"
            data-testid="close-header-categories"
            @click="selectCategory(categories[0].parentId ?? '')"
        />
    </div>
</template>

<style scoped lang="scss">
  .cp-nav-menu-categories-header {
    display: flex;
    align-items: center;
    border-bottom: $cp-border-standard;
    padding: $cp-gutter;

    &__parent {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__current {
      display: flex;
      align-items: center;
      flex-grow: 1;
    }
    &__img {
      flex-grow: 0;
      margin-right: $cp-gutter-small;
    }

    &__text{
      text-align: left;
      max-height: 32px;
      overflow: hidden;

    }
  }
</style>
